import axios from 'axios'
import updatePriority from 'gatsby-theme-centurylink/src/utils/updatePriority'

export default async function zipLogic(zipCode, isSpanishURL) {
  const apiKey = process.env.apiKey || '8b1370a310dc4af0b370071303f359a5'
  const datasetUrl = `https://dm.clear.link/api/datasets/centurylink-internet/find?search[ZIP_CD]=${zipCode}`

  try {
    const { data: submissionData } = await axios.get(datasetUrl, {
      headers: { 'X-Api-Key': apiKey },
    })

    const zipData = submissionData?.dataset?.data?.[0] || null

    if (zipData) {
      const { data: dataCTL } = await axios.get(
        'https://brandy.clear.link/data/brand/CTL'
      )

      let packagesToShow

      switch (zipData.CTL_Product_Group) {
        case 'Fiber 500':
          packagesToShow = ['ctl-fiber-500', 'ctl-copper100']
          break
        case 'Fiber Gig':
          packagesToShow = ['ctl-fiber-940', 'ctl-fiber-500', 'ctl-copper100']
          break
        case 'Copper':
          packagesToShow = ['ctl-copper100']
          break
        default:
          packagesToShow = []
          break
      }

      const packageSectionData = packagesToShow
        .map((pkg) => {
          const attributes = dataCTL?.data?.[pkg]?.attributes
          const name = dataCTL?.data?.[pkg]?.name

          if (!attributes || !name) return null

          const bullets = Object.keys(attributes)
            .filter(
              (key) =>
                key.startsWith('bullets-') && !key.endsWith('-disclaimer')
            )
            .map((key) => {
              const text = attributes[key]
              const identifier = key.replace('bullets-', '')
              const disclaimerText =
                attributes[`bullets-${identifier}-disclaimer`]
              const disclaimerSymbol =
                attributes[`bullets-${identifier}-disclaimer-symbol`]
              const disclaimer = disclaimerText
                ? { text: disclaimerText, symbol: disclaimerSymbol }
                : null

              return disclaimer ? { text, disclaimer } : { text }
            })

          return {
            label: '',
            packageName: pkg,
            brandy: {
              name,
              bullets,
              price: {
                before: attributes['pricing-before'] || '',
                amount: attributes['pricing-amount'],
                duration: attributes['pricing-duration'],
                disclaimer: { text: attributes['pricing-disclaimer'] },
              },
            },
          }
        })
        .filter(Boolean)

      zipData.packages = packageSectionData
      updatePriority(isSpanishURL ? 631 : 626)
      return zipData
    }

    updatePriority(isSpanishURL ? 630 : 625)
    return { packages: [] }
  } catch (error) {
    console.error(`Error fetching data for ZIP code: ${zipCode}`, error)
    return null
  }
}
